import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function useLocalePath() {
  const { locale } = useParams<{ locale: string }>();
  const { i18n } = useTranslation();
  const currentLocale = locale || i18n.language || "en";

  /** Prefix an internal path with the current locale */
  const localePath = (path: string) => {
    if (path.startsWith("http")) return path;
    const clean = path.startsWith("/") ? path : `/${path}`;
    return `/${currentLocale}${clean}`;
  };

  return { localePath, locale: currentLocale };
}
